import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=96cd949e&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=ts"
export * from "./Logs.vue?vue&type=script&lang=ts"
import style0 from "./Logs.vue?vue&type=style&index=0&id=96cd949e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cd949e",
  null
  
)

export default component.exports